import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Table, CardFooter } from 'reactstrap';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import { getErrorMessage } from 'helpers/errors';
import { getInsurersACobrar, OSaCobrar } from 'features/insurers/insurersAPI';
import { fCurrency } from 'helpers/formatNumber';
import Pagination from 'components/Pagination';

export default function ACobrar() {
  const [showAlert, message, alert] = useAlert(false, '');
  const [data, setData] = useState<OSaCobrar>();

  useEffect(() => {
    getInsurersACobrar()
      .then(newData => {
        setData(newData);
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudo obtener la información de las obras sociales');
      });
  }, []);

  const changePage = (newPage: number) => {
    getInsurersACobrar({ page: newPage })
      .then(newData => {
        setData(newData);
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudo obtener la información de las obras sociales');
      });
  };

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>Obras Sociales a Cobrar</Col>
                <Col md={4} className="text-right">
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>Obra Social</th>
                    <th>Periodo</th>
                    <th>Afiliado</th>
                    <th>Sesiones</th>
                    <th style={{ textAlign: 'right' }}>Importe Facturado</th>
                    <th style={{ textAlign: 'right' }}>Coseguro</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    data?.data.map((row, idx) => (
                      <tr key={idx}>
                        <td>{ row.obras }</td>
                        <td>{ row.periodo }</td>
                        <td>{ row.afiliado }</td>
                        <td>{ row.sesiones }</td>
                        <td style={{ textAlign: 'right' }}>{ fCurrency(row.facturado) }</td>
                        <td style={{ textAlign: 'right' }}>{ fCurrency(row.coseguro) }</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
            <CardFooter>
              <Pagination
                page={ data?.pagination.current ?? 1 }
                pages={ data?.pagination.total ?? 1 }
                onChangePage={ changePage }
              />
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
